@if (breakpoint.lgAndLarger() || !isMobileSlider()) {
  <div
    class="mobi-ui-grid"
    [class.is-centered]="(teaserStyle() === 'stacked' || centerRows()) && !notCentered()"
  >
    @for (teaser of teasers(); let i = $index; track teaser?.uuid ?? i) {
      @if (teaser) {
        <div
          class="self-stretch mobi-ui-col-1/1 sm:mobi-ui-col-1/2"
          [ngClass]="{ 'lg:mobi-ui-col-1/3': teaserWidth() }"
        >
          <mobi-teaser
            class="mobi-teaser-card"
            [teaserIllustration]="teaser.teaserIllustration"
            [teaserIcon]="teaser.teaserIcon?.symbol"
            [teaserImage]="teaser.teaserImage"
            [teaserText]="teaser.teaserText"
            [teaserTextShort]="teaser.teaserTextShort"
            [teaserTitle]="teaser.teaserTitle"
            [teaserUrl]="
              isCalcov()
                ? (teaser.url
                  | extractUrl
                  | calcUrl: (teaser.calculatorCtaAuth | extractUrl))
                : (teaser.url | extractUrl)
            "
            [teaserUrlTitle]="teaser.url?.title"
            [teaserTarget]="resolveTeaserTarget(teaser)"
            [secondaryActionUrl]="
              (isCalcov()
                ? (teaser.calculatorCta | extractUrl)
                : (teaser.calculatorCta
                  | extractUrl
                  | calcUrl: (teaser.calculatorCtaAuth | extractUrl))) ||
              (teaser.consultationCta | extractUrl)
            "
            [secondaryActionTarget]="teaser.calculatorCta?.options?.attributes?.target"
            [secondaryActionText]="
              teaser.calculatorCta?.title ||
              teaser.consultationCta?.title ||
              secondaryCtaLabel()
            "
            [secondaryActionIcon]="teaser.calculatorCta ? 'calculator' : 'right'"
            [bundle]="teaser.bundle"
            [teaserStyle]="teaserStyle()"
            [teaserIllustration]="teaser.teaserIllustration"
            [teaserTitleSize]="teaserTitleSize()"
            teaserTitleStyle="h5"
            [inked]="inked()"
            [overrideResponsiveStyle]="overrideResponsiveStyle()"
            [trackingId]="teaser.uuid"
            [customTrackingData]="getTrackingData(teaser)"
            [procovIllu]="teaser?.procovIllu"
            [isJubi]="(teaser.isJubi || false) && teaserStyle() === 'card'"
            [interceptPrimaryCta]="hasPrerollout(teaser)"
            (primaryCtaClick)="onPrimaryCtaClick($event, teaser)"
          ></mobi-teaser>
        </div>
      }
    }
  </div>
}
@if (breakpoint.mdMax() && isMobileSlider()) {
  <div>
    <mobi-ui-carousel-major [infinite]="true" [maxColumns]="breakpoint.xsMax() ? 1 : 2">
      @for (teaser of teasers(); track teaser?.uuid ?? $index) {
        @if (teaser) {
          <div>
            <mobi-teaser
              [published]="teaser.published"
              [teaserIllustration]="teaser.teaserIllustration"
              [teaserIcon]="teaser.teaserIcon?.symbol"
              [teaserImage]="teaser.teaserImage"
              [teaserText]="teaser.teaserText"
              [teaserTextShort]="teaser.teaserTextShort"
              [teaserTitle]="teaser.teaserTitle"
              [teaserUrl]="
                isCalcov()
                  ? (teaser.url
                    | extractUrl
                    | calcUrl: (teaser.calculatorCtaAuth | extractUrl))
                  : (teaser.url | extractUrl)
              "
              [teaserTarget]="resolveTeaserTarget(teaser)"
              [secondaryActionUrl]="
                isCalcov()
                  ? (teaser.calculatorCta | extractUrl)
                  : (teaser.calculatorCta
                    | extractUrl
                    | calcUrl: (teaser.calculatorCtaAuth | extractUrl))
              "
              [secondaryActionTarget]="
                teaser.calculatorCta?.options?.attributes?.target ||
                teaser.consultationCta?.options?.attributes?.target ||
                '_self'
              "
              [secondaryActionText]="teaser.calculatorCta?.title"
              secondaryActionIcon="calculator"
              [bundle]="teaser.bundle"
              [teaserStyle]="teaserStyle()"
              [teaserIllustration]="teaser.teaserIllustration"
              [teaserTitleSize]="teaserTitleSize()"
              teaserTitleStyle="h5"
              [inked]="inked()"
              [overrideResponsiveStyle]="overrideResponsiveStyle()"
              [trackingId]="teaser.uuid"
              [customTrackingData]="getTrackingData(teaser)"
              [procovIllu]="teaser.procovIllu"
              [isJubi]="(teaser.isJubi || false) && teaserStyle() === 'card'"
              [interceptPrimaryCta]="hasPrerollout(teaser)"
              (primaryCtaClick)="onPrimaryCtaClick($event, teaser)"
            ></mobi-teaser>
          </div>
        }
      }
    </mobi-ui-carousel-major>
  </div>
}
